
import SliderVertical from "../../../assets/outline/SliderVertical.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SliderVerticalIcon({ className, dataTestid = "SliderVerticalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SliderVertical data-testid={dataTestid} className={classes} {...rest} />
  );
}
